const SupportTypes = {
  CONTACT: 'CONTACT',
  FEEDBACK: 'FEEDBACK',
  ISSUE_REPORTING: 'ISSUE_REPORTING'
};

export default SupportTypes;
